import { Link } from "react-router-dom";
import ErrorComponent from "./index";

export default function Error404() {
  return (
    <ErrorComponent>
      <h1 className="display-1 mb-3">404</h1>
      <p className="text-muted">We seem to have misplaced that page.</p>
      <Link to="/" className="btn btn-primary ml-1">
        Back to Home
      </Link>
    </ErrorComponent>
  );
}
